import { leerSesion } from "../api.ts";
import { useClinica } from "../clinica.ts";

/** Encabezado de los documentos impresos: logo, nombre, razón social, RUC y datos de contacto de la clínica. */
export function Membrete() {
  const c = useClinica();
  const s = leerSesion();
  const sede = c?.sedes.find((x) => x.activa);
  const contacto = [sede?.direccion, sede?.telefono || c?.telefono, c?.correo].filter(Boolean).join(" · ");
  return (
    <div className="membrete">
      {c?.logoUrl && <img src={c.logoUrl} alt={`Logo de ${c.nombre}`} />}
      <div>
        <b>{c?.nombre ?? s?.usuario.clinica ?? "Clínica"}</b>
        {(c?.razonSocial || c?.ruc) && <small>{c.razonSocial}{c.razonSocial && c.ruc ? " · " : ""}{c.ruc && `RUC ${c.ruc}`}</small>}
        {contacto && <small>{contacto}</small>}
      </div>
    </div>
  );
}
